import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { Link, useTypedParams } from '@sorare/routing';

import { LabelS } from '@sorare/core/src/atoms/typography';
import { FOOTBALL_PLAY_REWARDS_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';
import { fantasy } from '@sorare/core/src/lib/glossary';

import {
  ProHistoryFixtureLayout,
  loaderFn,
} from '@sorare/gameplay/src/layouts/ProHistoryFixtureLayout';

import { PageParams } from './__generated__/routeParams';

export const loader = loaderFn<PageParams>();

const StyledLink = styled(Link)`
  position: absolute;
  bottom: var(--triple-unit);
  right: var(--double-unit);
`;

const FootballHistoryFixtureLayout = () => {
  const { fixture } = useTypedParams<PageParams>();
  return (
    <ProHistoryFixtureLayout<PageParams>
      rewardsPoolLink={
        <StyledLink
          to={generatePath(FOOTBALL_PLAY_REWARDS_FIXTURE, {
            fixture,
          })}
        >
          <LabelS as="p" color="var(--c-brand-300)">
            <FormattedMessage {...fantasy.viewRewardsPool} />
          </LabelS>
        </StyledLink>
      }
    />
  );
};
export default FootballHistoryFixtureLayout;
